import { useState } from "react";
import { openModal } from "./data";
import { ArrowCta, Eyebrow, MaskLines, Reveal } from "./ui-bits";

const Panel = ({
  dark,
  eyebrow,
  lines,
  copy,
  cta,
  modal,
  index,
  hovered,
  setHovered,
  testId,
}) => (
  <div
    className={`flex basis-0 flex-col justify-between gap-14 p-8 transition-all duration-700 ease-out md:p-16 ${
      dark ? "bg-obsidian text-ivory" : "bg-ivory text-obsidian"
    } min-h-[62vh] lg:min-h-[84vh]`}
    style={{ flexGrow: hovered === null ? 1 : hovered === index ? 1.22 : 0.78 }}
    onMouseEnter={() => setHovered(index)}
    onMouseLeave={() => setHovered(null)}
    data-testid={testId}
  >
    <Eyebrow tone={dark ? "champagne" : "dark"}>{eyebrow}</Eyebrow>
    <div>
      <h3 className="font-serif text-4xl leading-[1.02] sm:text-5xl lg:text-6xl">
        <MaskLines lines={lines} />
      </h3>
      <Reveal delay={0.2}>
        <p
          className={`mt-6 max-w-md text-sm leading-relaxed md:text-base ${
            dark ? "text-ivory/60" : "text-obsidian/70"
          }`}
        >
          {copy}
        </p>
        <div className="mt-8">
          <ArrowCta dark={!dark} onClick={() => openModal(modal)} testId={`${testId}-cta`}>
            {cta}
          </ArrowCta>
        </div>
      </Reveal>
    </div>
  </div>
);

const TwoSides = () => {
  const [hovered, setHovered] = useState(null);
  return (
    <section
      id="model"
      className="flex flex-col lg:flex-row"
      data-testid="two-sides-section"
    >
      <Panel
        dark
        index={0}
        hovered={hovered}
        setHovered={setHovered}
        eyebrow="For Occupiers"
        lines={["FIND YOUR", "NEXT SPACE."]}
        copy="Tell us what your business needs. We'll identify locations that fit your brand, customers, operations and commercial objectives."
        cta="Find a Space"
        modal="find"
        testId="panel-occupiers"
      />
      <Panel
        index={1}
        hovered={hovered}
        setHovered={setHovered}
        eyebrow="For Landlords"
        lines={["FIND YOUR", "NEXT TENANT."]}
        copy="Position your property, reach the right occupiers and maximise its leasing potential with a strategy built around your asset."
        cta="List Your Property"
        modal="list"
        testId="panel-landlords"
      />
    </section>
  );
};

export default TwoSides;
